import React from 'react';
import { formatLottoDate } from '../../utils/date';
import { formatCategory } from '../../utils/marketTypeHelpers';
import infoIcon from '../../../../../../shared/assets/images/lotto-assistant/ticket-info.svg';
import classes from './BetTicket.module.scss';

const BetTicketHeader = ({ ticket, hasBalls, onInfoClick, onRemoveTicket }) => (
  <div className={classes.Header}>
    {onRemoveTicket && (
      <button
        type="button"
        onClick={onRemoveTicket}
        className={classes.CloseButton}
        aria-label="Remove ticket"
      >
        ✕
      </button>
    )}

    <div className={classes.HeaderRow}>
      <button
        type="button"
        onClick={onInfoClick}
        className={classes.InfoButton}
        aria-label="Lottery info"
      >
        <img src={infoIcon} alt="" width={40} height={40} />
      </button>
      <h3 className={classes.LotteryName}>{ticket.lottery_name}</h3>
    </div>

    <div className={classes.HeaderInfo}>
      <div className={classes.LabelGroup}>
        <span className={classes.Label}>DRAW DATE</span>
        <span className={classes.LabelText}>
          {formatLottoDate(ticket.draw_date).replace(' ', ' · ')}
        </span>
      </div>
      <div className={classes.LabelGroup}>
        <span className={classes.Label}>{hasBalls ? 'TYPE' : 'CATEGORY'}</span>
        <span className={classes.LabelText}>
          {hasBalls
            ? ticket.market_title
            : formatCategory(ticket.market_category)}
        </span>
      </div>
    </div>
  </div>
);

export default BetTicketHeader;
